import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import LoadingButton from "../../../shared/ui/LoadingButton";
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import '../test-templates/TestTemplates.scss'
import {withRouter} from "react-router-dom";
import QuestionList from "../test-templates/QuestionList";
import QuizQuestionsList from './QuizQuestionsList';
import testsActionCreators from "../../store/tests/action-creators";
import {formatDate} from "../../../shared/services/utils/utils";

function mapStateToProps(state) {
  return {
    tests: state.tests.list,
    testsMap: state.tests.map,
    userContext: state.common.userContext,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTests() {
      return dispatch(testsActionCreators.fetchMyTests());
    },
    submitTest(form, id) {
      return dispatch(testsActionCreators.submitTest(form, id));
    },
    startTest(form) {
      return dispatch(testsActionCreators.startTest(form));
    },
    retryTestEnd() {
      return dispatch(testsActionCreators.retryTestEnd());
    },
    gradeAnswer(form) {
      return dispatch(testsActionCreators.gradeAnswer(form));
    },
    finishGradeTest(id) {
      return dispatch(testsActionCreators.finishGradeTest(id));
    },
    fetchTestsForGrade() {
      return dispatch(testsActionCreators.fetchTestsForGrade());
    },
  };
}

class TestTemplateDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isAddingQuestion: false,
      isEditingQuestion: null,
      isLoadingCreate: false
    }
  }

  get test() {
    return this.props.testsMap[this.state.selectedGuid];
  }

  get isTest() {
    return this.test && (
      (this.test.questions && this.test.started_at && this.test.test_template.mode === 'test')
      || this.test.status === 'completed' || this.test.status === 'waiting'
    );
  }

  get isQuiz() {
    return this.test && (
      (this.test.questions && this.test.started_at && this.test.test_template.mode === 'quiz')
      && (this.test.status !== 'completed' && this.test.status !== 'waiting')
    );
  }

  componentDidMount() {
    if (this.props.userContext.hasScope('oit')) {
      this.setState({
        isLoading: true,
        selectedGuid: this.props.match.params.guid
      });

      this.props.fetchTests()
        .then(() => {
          this.setState({
            isLoading: false
          });
        })
        .catch(() => {
          this.setState({
            isLoading: false
          });
        })
    } else if (!this.props.testsMap[this.props.match.params.guid]) {
      window.location.href = '/tests'
    } else {
      this.setState({
        selectedGuid: this.props.match.params.guid
      });
    }
  }

  onTestRetried(newTest) {
    this.setState({
      selectedGuid: newTest.id
    });

    this.props.history.push(`/tests/${newTest.id}`);
  }

  onEditQuestion(question) {
    this.setState({
      isEditingQuestion: {...question}
    })
  }

  submitTest(form) {
    return this.props.submitTest(form, this.test.id)
  }

  finishGradeTest() {
    return this.props.finishGradeTest(this.test.id)
      .then(() => {
        this.props.fetchTestsForGrade()
        window.scrollTo(0, 0)
      })
  }

  startTest() {
    let form = {
      id: this.test.id,
      started_at: (new Date).toISOString()
    }

    return this.props.startTest(form)
  }

  gradeAnswer(form) {
    return this.props.gradeAnswer({...form, id: this.test.id})
  }

  render() {
    return (
      <LoadingOverlay isLoading={!this.test}>
        <div className="app-content-header">
          <h4 className="title">{this.test ? formatDate(this.test.schedule) : ''} {this.test? this.test.user.firstName: ''} {this.test? this.test.user.lastName: ''}</h4>
        </div>
        <div className="test-templates app-content">
          {(this.test && !this.test.started_at) &&
          <div className="start-test-btn">
            {!!this.test.test_template.duration && <div>
              Test Duration: {this.test.test_template.duration} minutes
            </div>}

              <LoadingButton
                primary
                text="Start Test"
                onClick={() => this.startTest()}
                isLoading={this.state.isLoading}
              />
            </div>
          }
          <div className="test-templates-card">
            {this.isTest && (
              <Fragment>
                <QuestionList
                  key={this.test.status}
                  questions={this.test.questions}
                  testTemplate={this.test.test_template}
                  testObj={this.test}
                  answers={this.test.answers}
                  passed={this.test.passed}
                  score={this.test.score}
                  canEdit={false}
                  status={this.test.status}
                  onEdit={(question) => this.onEditQuestion(question)}
                  passingScore={this.test.passing_score}
                  onTestRetried={(newTest) => this.onTestRetried(newTest)}
                  showAnswer={this.test.test_template.allowTakerViewCorrectAnswer}
                  onSubmit={(form) => this.submitTest(form)}
                  onGradeAnswer={(form) => this.gradeAnswer(form)}
                  onFinishTest={(form) => this.finishGradeTest(form)}
                />
              </Fragment>
            )}
            {this.isQuiz &&
            <Fragment>
              <QuizQuestionsList
                key={this.test.status}
                questions={this.test.questions}
                testTemplate={this.test.test_template}
                testObj={this.test}
                answers={this.test.answers}
                passed={this.test.passed}
                score={this.test.score}
                canEdit={false}
                  status={this.test.status}
                  onEdit={(question) => this.onEditQuestion(question)}
                  passingScore={this.test.passing_score}
                  onTestRetried={(newTest) => this.onTestRetried(newTest)}
                  showAnswer={this.test.test_template.allowTakerViewCorrectAnswer}
                  onSubmit={(form) => this.submitTest(form)}
                />
              </Fragment>
            }
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TestTemplateDetails));
